/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import { FormController } from '../form/FormController';
import { FormLabel } from '../form/FormLabel';
import { FormHelpMessage } from '../form/FormHelpMessage';
import { FormStatusMessage } from '../form/FormStatusMessage';
import { Dropdown } from './Dropdown';

const DropdownField = (props) => {
  const {
    label,
    messageText,
    disabled,
    status,
    children,
    helpMessage,
    statusMessage,
    id: idProp,
    ...rest
  } = props;

  const id = idProp || nanoid();
  const formLabelId = label && id ? `${id}-label` : undefined;
  const helpMessageId = helpMessage && id ? `${id}-help-message` : undefined;
  const statusMessageId = statusMessage && id ? `${id}-status-message` : undefined;
  const ariaDescribedby = [];
  if (helpMessageId) ariaDescribedby.push(helpMessageId);
  if (statusMessageId) ariaDescribedby.push(statusMessageId);

  return (
    <FormController disabled={disabled} status={status}>
      <FormLabel
        htmlFor={id}
        id={formLabelId}
      >
        {label}
      </FormLabel>
      <Dropdown
        id={id}
        {...rest}
        disabled={disabled}
        ariaDescribedby={ariaDescribedby.length ? ariaDescribedby.join(' ') : undefined}
      >
        {children}
      </Dropdown>
      {statusMessage && (
        <FormStatusMessage id={statusMessageId}>
          {statusMessage}
        </FormStatusMessage>
      )}
      {helpMessage && (
        <FormHelpMessage id={helpMessageId}>
          {helpMessage}
        </FormHelpMessage>
      )}
    </FormController>
  );
};

DropdownField.displayName = 'DropdownField';

DropdownField.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  messageText: PropTypes.string,
  status: PropTypes.oneOf(['error', 'success', 'warning']),
  /**
   * The description for the TextField component.
   */
  helpMessage: PropTypes.string,
  /**
   * Adds a message when there is a status value.
   */
  statusMessage: PropTypes.string
};

export { DropdownField };